module.exports = __webpack_public_path__ + "static/media/FutureMenu.c2c1f0a5.jpg";